(() => {
  const dialog = document.getElementById('HalloweenOffer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const start = Date.parse('2026-10-15T00:00:00+02:00');
  const end = Date.parse('2026-10-31T23:59:59+01:00');
  const week = 7 * 24 * 60 * 60 * 1000;
  const key = 'intimoin:halloween2026:last-shown';
  let previousFocus;
  let attempts = 0;
  let expiry;
  const now = () => Date.now();
  const campaignActive = () => now() >= start && now() <= end;
  const recentlySeen = () => {
    try { const last = Number(localStorage.getItem(key)); return last > 0 && now() - last < week; }
    catch { return true; } // Avoid repeatedly interrupting visitors if storage is unavailable.
  };
  const close = () => dialog.close();
  dialog.querySelector('.halloween-offer__close').addEventListener('click', close);
  dialog.querySelector('.halloween-offer__later').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('halloween-offer-open');
    clearTimeout(expiry);
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({preventScroll: true});
  });
  dialog.querySelector('.halloween-offer__cta').addEventListener('click', (event) => {
    if (!campaignActive()) { event.preventDefault(); close(); }
  });
  const tryOpen = () => {
    if (!campaignActive() || recentlySeen() || window.Shopify?.designMode) return;
    const busy = document.visibilityState !== 'visible' ||
      [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner')]
        .some(el => el !== dialog && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden') ||
      /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
    if (busy) { if (++attempts < 120) setTimeout(tryOpen, 2000); return; }
    try { localStorage.setItem(key, String(now())); } catch { return; }
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('halloween-offer-open');
    expiry = setTimeout(close, Math.min(end - now() + 1, 2147483647));
  };
  setTimeout(tryOpen, 8000);
})();
